import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  List as ListIcon,
} from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

/** Coleta todos os row ids das seções para os handles */
function getAllRowIds(sections) {
  if (!Array.isArray(sections)) return [];
  return sections.flatMap((sec) => (sec.rows || []).map((r) => r.id).filter(Boolean));
}

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const sections = data?.sections || [];
  const rowIds = getAllRowIds(sections);

  return (
    <div
      style={{
        backgroundColor: "#FAFBFF",
        padding: "8px",
        borderRadius: "8px",
        maxWidth: "200px",
        boxShadow: "0px 3px 5px rgba(0,0,0,.05)",
        border: "1px solid rgba(104, 58, 200, 0.25)",
        width: 200,
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#9a00ed",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px",
          cursor: "pointer",
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#683AC8" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#683AC8" }}
        />
      </div>
      <div
        style={{
          color: "#ededed",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <ListIcon
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#683AC8",
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px" }}>Lista</div>
      </div>
      <div
        style={{
          color: "#232323",
          fontSize: "12px",
          minHeight: "40px",
          overflow: "hidden",
          marginBottom: "8px",
        }}
      >
        {data?.message || "Mensagem com lista"}
      </div>
      {sections.length > 0 && (
        <div style={{ fontSize: "10px", color: "#666" }}>
          {sections.length} seção(ões) · {rowIds.length} opção(ões)
        </div>
      )}
      {rowIds.map((rowId, idx) => (
        <div
          key={rowId}
          style={{
            marginBottom: "6px",
            justifyContent: "end",
            display: "flex",
          }}
        >
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "10px",
              color: "#232323",
            }}
          >
            {rowId}
          </div>
          <Handle
            type="source"
            position="right"
            id={String(rowId)}
            style={{
              top: 90 + 22 * idx,
              background: "#9a00ed",
              width: "18px",
              height: "18px",
              right: "-11px",
              cursor: "pointer",
            }}
            isConnectable={isConnectable}
          >
            <ArrowForwardIos
              sx={{
                color: "#ffff",
                width: "10px",
                height: "10px",
                marginLeft: "2.9px",
                marginBottom: "1px",
                pointerEvents: "none",
              }}
            />
          </Handle>
        </div>
      ))}
    </div>
  );
});
